import axios from 'axios';
import utils from './util';
import { Config } from './config';
import {
  showFullScreenLoading, tryHideFullScreenLoading, toLogin, timeOutScreenLoading,
} from '../plugin/loading/loading';

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'; // 全局的 axios 默认值，设置post请求的默认content-type
const http = {
  _addParams: (params) => {
    if (params && utils.isObject(params)) {
      const headerJson = {
        SERVICE_ID: params.SERVICE_ID,
        OTYPE: params.OTYPE,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
      };
      delete params.SERVICE_ID;
      delete params.OTYPE;
      delete params.USER_ID;
      delete params.SESSION;
      if (headerJson.SERVICE_ID) {
        const reqMsg = { REQUEST: { HDR: headerJson, DATA: params } };
        return JSON.stringify(reqMsg);
      }
      throw new Error('请检查相关参数的功能号(SERVICE_ID)');
    }
    throw new Error('请求参数不合法，请检查调用参数！');
  },
  post: (param, options = { showLoading: true }) => {
    const { showLoading } = options
    if (showLoading) {
      showFullScreenLoading();
    }
    const params = http._addParams(param);
    const url = Config.baseUrl;
    return new Promise((resolve, reject) => {
      axios.post(url, params, {
        timeout: 9000000,
      }).then((result) => {
        const code = result.data.ANSWER.HDR.CODE;
        if (code !== Config.OK_CODE) {
          const { TEXT } = result.data.ANSWER.HDR;
          if (TEXT === '验证不通过' || TEXT === '验证不通过，请重新登陆' || TEXT === '登陆已过期，请重新登陆' || TEXT === '登陆已过期，请从新登陆') {
            toLogin();
          }
          reject(TEXT);
        } else {
          resolve(result.data.ANSWER.DATA);
        }

        if (showLoading) {
          tryHideFullScreenLoading();
        }
      }).catch((error) => {
        timeOutScreenLoading();
        console.log(`网络异常，请刷新重试！${error}`);
      });
    });
  },
};
export default http;



// WEBPACK FOOTER //
// ./src/assets/common/http.js